/**
 * Auto-generated API Client
 *
 * Generated by @spfn/core codegen
 * DO NOT EDIT MANUALLY
 *
 * @generated 2025-11-03T13:40:07.036Z
 */

import { client } from '@spfn/core/client';
import type { InferContract } from '@spfn/core';

import { getLabelsContract, createLabelContract, getLabelContract, updateLabelContract, deleteLabelContract } from '@/lib/contracts/labels';

// ============================================
// Types
// ============================================

export type GetLabelsResponse = InferContract<typeof getLabelsContract>['response'];
export type GetLabelsQuery = InferContract<typeof getLabelsContract>['query'];

export type CreateLabelResponse = InferContract<typeof createLabelContract>['response'];
export type CreateLabelBody = InferContract<typeof createLabelContract>['body'];

export type GetLabelResponse = InferContract<typeof getLabelContract>['response'];
export type GetLabelParams = InferContract<typeof getLabelContract>['params'];

export type UpdateLabelResponse = InferContract<typeof updateLabelContract>['response'];
export type UpdateLabelParams = InferContract<typeof updateLabelContract>['params'];
export type UpdateLabelBody = InferContract<typeof updateLabelContract>['body'];

export type DeleteLabelResponse = InferContract<typeof deleteLabelContract>['response'];
export type DeleteLabelParams = InferContract<typeof deleteLabelContract>['params'];

// ============================================
// API Functions
// ============================================

/**
 * GET /_cms/labels
 */
export const getLabels = (options: { query?: GetLabelsQuery }) => client.call(getLabelsContract, options);

/**
 * POST /_cms/labels
 */
export const createLabel = (options: { body: CreateLabelBody }) => client.call(createLabelContract, options);

/**
 * GET /_cms/labels/:id
 */
export const getLabel = (options: { params: GetLabelParams }) => client.call(getLabelContract, options);

/**
 * PATCH /_cms/labels/:id
 */
export const updateLabel = (options: { params: UpdateLabelParams, body: UpdateLabelBody }) => client.call(updateLabelContract, options);

/**
 * DELETE /_cms/labels/:id
 */
export const deleteLabel = (options: { params: DeleteLabelParams }) => client.call(deleteLabelContract, options);

